// TextwithImageData.js

// Section Data for Text and Image Components
const textSections = {
    pageOne: {
      heading: "We make global contractor management work for you.",
      paragraph: `We empower recruitment agencies to compliantly place contractors in
      40+ countries worldwide. \n\n Having worked with some of the biggest names
        in the industry, we remove the barriers to entry and handle all
        aspects of contractor payroll, onboarding, and employment compliance,
        so you can easily place candidates in any country.`,
      buttonText: "Find out more",
      imageSrc: "images/img4.png",
      imageAlt: "Contractor Management",
      imagePosition: "right",
        url:"/meet-the-experts"
    },
    pageTwo: {
      heading: "Simplify global hiring with us.",
      listItems: [
        "Assignment Tracker View: contractor assignments, start dates, and statuses in a single dashboard.",
        "Referral System: Refer contractors directly via the platform, eliminating email back-and-forth.",
        "Global Compliance: Collect and verify employment documents for every country.",
      ],
      buttonText: "Discover More",
      imageSrc: "images/img5.png",
      imageAlt: "Global Hiring",
      imagePosition: "left",
    },
    pageThreeEor: {
      heading: "What’s Included in Our Solution?",
      listItems: [
        "Worker Payroll",
        "Seamless Onboarding",
        "No Hidden Fees",
        "Employment Tax",
        "Best-in Class Benefits",
        "Employment Compliance",
        "Comprehensive Insurances",
        "No Local Entity Required"
      ],
      buttonText: "",
      imageSrc: "/images/blog1.jpg",
      imageAlt: "Global Hiring",
      imagePosition: "right",
      classname:"Eorlist"
    },
    pageContlist: {
      heading: "What’s Included in Our Contingent Workforce Solution?",
      listItems: [
        "Contractor Engagement in 40+ Countries",
        "Accurate Payment Solutions for Freelancers",
        "Expert Insights on Local Compliance",
        "Electronic Worker Verification",
        "Timesheet Management",
        "Seamless Onboarding & Offboarding",
        "Workforce Management Tech Platform"
      ],
      buttonText: "",
      imageSrc: "/images/blog1.jpg",
      imageAlt: "Global Hiring",
      imagePosition: "right",
      classname:"Eorlist"
    },
    pagefourCont: {
      heading: "Engage Contingent Workers Globally",
      paragraph: "Do you need short-term talent to meet project demands or specific skills on a contract basis? We’re not surprised! In recent years there has been an ever-increasing demand for contingent workers from businesses across the globe Engaging freelancers and independent contractors globally can be challenging due to varying local regulations and compliance requirements. However, that’s where Ampstekpay steps in to help.",
      buttonText: "Find out more",
      imageSrc: "/images/img2.jpg",
      imageAlt: "Global Hiring",
      imagePosition: "right",
      classname:"contingent",
      url:"/meet-the-experts"
    },
    PageStaffingEor: {
      heading: "Global Employer of Record (EOR) Solutions by Ampstek: Simplifying International Hiring and Compliance",
      paragraph: "Our scalable and compliant Employer of Record (EOR) solution at Ampstek enables recruitment agencies to place contractors in over 40 countries around the world.Ampstek handles all aspects of contractor payroll, onboarding, and employment compliance. This means you can place any contractor, wherever you need, without the need to set up a local entity.",
      buttonText: "Find out more",
      imageSrc: "/images/img6.jpg",
      imageAlt: "Global Hiring",
      imagePosition: "right",
      classname:"contingent",
      url:"/meet-the-experts"
    },
    PageStaffingEorList: {
      heading: "What’s Included in Ampstekpay's EOR Service?",
      listItems: [
        "Comprehensive EOR Solutions for Global Workforce Management",
        "Complete Global Workforce Compliance with Ampstekpay",
        "All-In-One EOR Service for Seamless Global Hiring",
        "End-to-End Solutions for Global Employment and Payroll",
        "Streamlined EOR Services for Efficient Global Expansion",
        "Optimized Global Employment Services for Recruitment Agencies",
        "Effortless Global Hiring with Our EOR Solutions"
      ],
      buttonText: "Meet our Experts",
      url:"/meet-the-experts",
      imageSrc: "/images/imgg1.jpg",
      imageAlt: "Global Hiring",
      imagePosition: "left",
      classname:"StaffingEorlist"
    },
    PageStaffingIndependentList: {
      heading: "What’s Included in Our Independent Contractor Service?",
      listItems: [
        "Risk Management & Legal Support",
        "Offboarding & Exit Procedures",
        "Contractor Engagement & Retention",
        "HR Support & Expertise",
        "Payroll Processing & Management",
        "Contractor Compliance Management",
        "Taxation & Withholding Support"
      ],
      buttonText: "Meet our Experts",
      url:"/meet-the-experts",
      imageSrc: "/images/imgg1.jpg",
      imageAlt: "Global Hiring",
      imagePosition: "left",
      classname:"StaffingEorlist"
    },
    pageStaffingIndependent: {
      heading: "Simplifying Global Contractor Management with Ampstekpay",
      paragraph: "As a recruitment agency, managing independent contractors across various regions can be complex, especially when it comes to ensuring compliance with local laws and regulations. Ampstekpay simplifies this process by offering comprehensive Employer of Record (EOR) services. We handle the entire lifecycle of contractor management—from onboarding and payroll to compliance and offboarding—so you can focus on what matters most: finding and placing top talent. With Ampstekpay, you can expand your reach globally, without the need for local entities, while staying fully compliant with regional requirements..",
      buttonText: "Find out more",
      imageSrc: "/images/ban4.jpg",
      imageAlt: "Global Hiring",
      imagePosition: "right",
      classname:"contingent",
      url:"/meet-the-experts"
    },
  };
  
  // Expert Page Data
  const ExpertPage = [
    {
      heading: "John Hoskin",
      subheading: "Global CEO of Ampstekpay Group",
      listItems: [
        "Joined Ampstekpay in 2017, following the acquisition of his digital accountancy and payroll business. He qualified with Deloitte’s mid-market London office as a Chartered Accountant and subsequently held a number of finance and commercial director positions in outsourcing, transport, and healthcare, before founding his own company.",
        "Provides strategic leadership to the Ampstekpay business.",
      ],
      author: "Yorkshire, UK",
      imageSrc: "images/img5.png",
      imageAlt: "Global Hiring",
      imagePosition: "left",
      classname: "expertPageList",
    },
    {
        heading: "Amy Davies",
        subheading: "Managing Director- Global Growth",
        listItems: [
          "With more than a decade experience of working alongside recruitment firms and international companies supporting their expansion and global workforce needs. Deep expertise in North American and UK markets, employment compliance, payroll, and operations.",
          "Oversees and manages all sales, marketing, and account management teams. Offers global expansion, strategy, and employment advice for business leaders. ",
        ],
        author: "Liverpool, UK",
        imageSrc: "images/ban2.jpeg",
        imageAlt: "Global Hiring",
        imagePosition: "left",
        classname: "expertPageList",
      },
      {
        heading: "Marc Gomez",
        subheading: "Managing Director- Global Operations",
        listItems: [
          "12+ years leading and opening global entities to provide in country employer of record services. Deep EU expertise in all employment operations ; including engagement models, onboarding, finance, accounting, payroll and more.",
          "Oversees and leads all operational teams ensuring compliance and high standards of services for our clients.  Deep technical expertise and knowledge to help businesses build global teams. ",
        ],
        author: "Barcelona, Spain",
        imageSrc: "images/img4.png",
        imageAlt: "Global Hiring",
        imagePosition: "left",
        classname: "expertPageList",
      }
  ];
  
  // Exporting the data for use in other components
  export { textSections, ExpertPage };
  